module.exports = __webpack_public_path__ + "img/ic_vk_light.2bb2c91b.svg";